module.exports = __webpack_public_path__ + "img/demoImage.78ab5953.svg";